import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { resetClientStatus } from '../../../actions/client'
import { Page } from '../..'

import SetMobileForm from './SetMobileForm'
import TwilioStartHelper from './TwilioStartHelper'

export const TEXT_UPDATE_PAGES = {
  UPDATE: '',
  OPT_IN: 'opt-in',
  TWILIO: 'twilio-help'
}

const TextUpdatesPanel = ({ match }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(resetClientStatus())
  }, [dispatch])

  return (
    <>
      {match.isExact && (
        <Page>
          <TwilioStartHelper updating />
        </Page>
      )}
      <Page key='opt-in' path={`${match.url}/${TEXT_UPDATE_PAGES.OPT_IN}`} component={SetMobileForm} />
      <Page key='twilio-help' path={`${match.url}/${TEXT_UPDATE_PAGES.TWILIO}`} component={TwilioStartHelper} />
    </>
  )
}

TextUpdatesPanel.propTypes = {
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    url: PropTypes.string
  })
}

export default TextUpdatesPanel
